(function () {
  'use strict';

  var byju = (window.byju = window.byju || {});
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  byju.toast = function (message) {
    var region = document.querySelector('[data-toast-region]');
    if (!region || !message) return;
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    region.replaceChildren(toast);
    window.setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 4200);
  };

  var drawer = (byju.drawer = {
    open: function (dialog, trigger) {
      if (!dialog || dialog.open) return;
      dialog._trigger = trigger || document.activeElement;
      dialog.showModal();
      document.body.classList.add('has-drawer');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          dialog.classList.add('is-open');
        });
      });
      var autofocus = dialog.querySelector('[data-autofocus]');
      if (autofocus) autofocus.focus();
      dialog.dispatchEvent(new CustomEvent('drawer:open'));
    },

    close: function (dialog) {
      if (!dialog || !dialog.open || dialog._closing) return;
      dialog._closing = true;
      dialog.classList.remove('is-open');
      var delay = reducedMotion.matches ? 0 : 320;
      window.setTimeout(function () {
        dialog.close();
        dialog._closing = false;
        if (!document.querySelector('dialog[open]')) {
          document.body.classList.remove('has-drawer');
        }
        var trigger = dialog._trigger;
        if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') {
          trigger.focus();
        }
        dialog.dispatchEvent(new CustomEvent('drawer:close'));
      }, delay);
    }
  });

  document.addEventListener(
    'cancel',
    function (event) {
      var dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('[data-drawer]')) {
        event.preventDefault();
        drawer.close(dialog);
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches('dialog[data-drawer]')) {
      drawer.close(target);
      return;
    }

    var opener = target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      drawer.open(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }

    var closer = target.closest('[data-drawer-close]');
    if (closer) {
      drawer.close(closer.closest('dialog'));
      return;
    }

    var searchOpener = target.closest('[data-search-open]');
    if (searchOpener) {
      var searchDialog = document.querySelector('.search-dialog');
      if (searchDialog) {
        event.preventDefault();
        drawer.open(searchDialog, searchOpener);
      }
    }
  });

  function syncQuantity(wrapper) {
    var input = wrapper.querySelector('input');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = value >= max;
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!button) return;
    var wrapper = button.closest('[data-quantity]');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var step = button.hasAttribute('data-qty-plus') ? 1 : -1;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + step));
    if (String(next) !== input.value) {
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncQuantity(wrapper);
  });

  document.addEventListener('change', function (event) {
    var wrapper = event.target instanceof Element && event.target.closest('[data-quantity]');
    if (wrapper) syncQuantity(wrapper);
  });

  byju.showJsOnly = function (scope) {
    (scope || document).querySelectorAll('[data-js-only][hidden]').forEach(function (el) {
      el.hidden = false;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      byju.showJsOnly();
    });
  } else {
    byju.showJsOnly();
  }

  function updateCounter(field) {
    var counter = document.querySelector('[data-count-for="' + field.id + '"]');
    if (counter) counter.textContent = field.value.length + '/' + field.maxLength;
  }

  document.addEventListener('input', function (event) {
    if (event.target instanceof HTMLElement && event.target.hasAttribute('data-counted')) updateCounter(event.target);
  });
  document.querySelectorAll('[data-counted]').forEach(updateCounter);

  function carouselState(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    root.classList.toggle('is-scrollable', max > 0);
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;
    var root = button.closest('[data-carousel]');
    var track = root && root.querySelector('[data-carousel-track]');
    if (!track) return;
    var direction = button.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (track instanceof Element && track.hasAttribute('data-carousel-track')) {
        carouselState(track.closest('[data-carousel]'));
      }
    },
    true
  );

  byju.initCarousels = function (scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(carouselState);
  };
  window.addEventListener('resize', function () {
    byju.initCarousels();
  });
  document.addEventListener('DOMContentLoaded', function () {
    byju.initCarousels();
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target instanceof HTMLSelectElement && target.hasAttribute('data-auto-submit') && target.form) {
      target.form.submit();
    }
  });

  var header = document.querySelector('[data-header]');
  if (header) {
    var ticking = false;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function closeSubmenus(except) {
    document.querySelectorAll('.nav__item.is-open').forEach(function (item) {
      if (item !== except) {
        item.classList.remove('is-open');
        var toggle = item.querySelector('[data-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var toggle = target.closest('[data-nav-toggle]');
    if (toggle) {
      var item = toggle.closest('.nav__item');
      var open = !item.classList.contains('is-open');
      closeSubmenus(item);
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!target.closest('.nav__item')) closeSubmenus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openItem = document.querySelector('.nav__item.is-open');
    if (openItem) {
      var toggle = openItem.querySelector('[data-nav-toggle]');
      closeSubmenus();
      if (toggle) toggle.focus();
    }
  });

  function initReveal(root) {
    var scope = root || document;
    var enabled =
      document.body.getAttribute('data-animations') === 'true' &&
      !reducedMotion.matches &&
      'IntersectionObserver' in window &&
      !(window.Shopify && window.Shopify.designMode);
    var items = scope.querySelectorAll('[data-reveal]:not([data-reveal="done"])');
    if (!items.length) return;

    if (!enabled) {
      items.forEach(function (el) {
        el.setAttribute('data-reveal', 'done');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var siblings = Array.prototype.filter.call(el.parentElement.children, function (child) {
            return child.hasAttribute('data-reveal');
          });

          siblings.forEach(function (sibling, i) {
            if (sibling.getAttribute('data-reveal') !== 'pending') return;
            sibling.style.setProperty('--reveal-delay', Math.min(i, 5) * 60 + 'ms');
            sibling.setAttribute('data-reveal', 'done');
            observer.unobserve(sibling);
          });
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        el.setAttribute('data-reveal', 'done');
        return;
      }
      el.setAttribute('data-reveal', 'pending');
      observer.observe(el);
    });
  }

  byju.observeReveal = initReveal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
    });
  } else {
    initReveal();
  }

  function initBenefitsAutoplay(scope) {
    (scope || document).querySelectorAll('[data-benefits-autoplay]').forEach(function (list) {
      if (list.getAttribute('data-autoplay-ready')) return;
      list.setAttribute('data-autoplay-ready', 'true');
      var interval = parseInt(list.getAttribute('data-interval'), 10) || 4000;
      var mobile = window.matchMedia('(max-width: 749px)');
      var paused = false;
      var visible = true;

      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
        }).observe(list);
      }

      var pause = function () {
        paused = true;
      };
      var resume = function () {
        window.setTimeout(function () {
          paused = false;
        }, interval);
      };
      ['touchstart', 'pointerdown', 'focusin', 'mouseenter'].forEach(function (name) {
        list.addEventListener(name, pause, { passive: true });
      });
      ['touchend', 'touchcancel', 'pointerup', 'focusout', 'mouseleave'].forEach(function (name) {
        list.addEventListener(name, resume, { passive: true });
      });

      window.setInterval(function () {
        if (paused || !visible || document.hidden || (!list.hasAttribute('data-autoplay-all') && !mobile.matches) || reducedMotion.matches) return;
        var max = list.scrollWidth - list.clientWidth - 2;
        if (max <= 0 || !list.children.length) return;
        if (list.scrollLeft >= max) {
          list.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          list.scrollBy({ left: list.children[0].getBoundingClientRect().width, behavior: 'smooth' });
        }
      }, interval);
    });
  }

  byju.initBenefitsAutoplay = initBenefitsAutoplay;
  initBenefitsAutoplay();

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initBenefitsAutoplay(event.target);
  });
})();
